import { ReactComponent as LockIcon } from '@vkontakte/icons/src/svg/16/lock_outline_16.svg';
import cn from 'clsx';
import React, { type ReactElement } from 'react';
import { SharingNewDropdown } from 'reactApp/components/SharingNewBiz/Dropdown/SharingNewDropdown';
import { domainAccessOptions, QA_VALUE, TOOLTIP_OFFSET } from 'reactApp/components/SharingNewBiz/SharingNew.constants';
import type { DomainAccess } from 'reactApp/components/SharingNewBiz/SharingNew.types';
import styles from 'reactApp/components/SharingNewBiz/Weblink/SharingNewWeblink.css';
import { Dropdown } from 'reactApp/ui/Dropdown/Dropdown';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';

interface Props {
    checked: DomainAccess;
    accessText: string;
    isPhone: boolean;
    renderDomesticDropdown: (onClick: void) => ReactElement;
    handleUpdateDomestic: (id: DomainAccess) => void;
    disabled?: boolean;
}

export const DomesticDropdownTemplate: React.FC<Props> = React.memo(
    ({ checked, accessText, isPhone, renderDomesticDropdown, handleUpdateDomestic, disabled }) => {
        const item = domainAccessOptions[checked];
        return (
            <div className={styles.rightsItem} data-qa-item={QA_VALUE.domesticItem}>
                <div className={styles.titleWrapper}>
                    <span className={styles.icon}>
                        <LockIcon />
                    </span>
                    <span className={styles.rightsTitle}>{accessText}</span>
                </div>
                <div className={cn(styles.dropdown, { [styles.dropdownAccess]: !isPhone })}>
                    <Dropdown
                        withinDialog
                        theme="octavius"
                        qaValue={item.id}
                        disabled={disabled}
                        as={SharingNewDropdown}
                        value={item.text}
                        content={renderDomesticDropdown}
                        onClickItem={handleUpdateDomestic}
                        placement={tooltipPlacements.BOTTOM_LEFT}
                        qaValueContent={QA_VALUE.domesticDropdownContent}
                        tooltipOffset={TOOLTIP_OFFSET}
                        animatedTooltip
                        tooltipClassName={isPhone ? styles.tooltip : undefined}
                        isPhone={isPhone}
                        noPageOffset={isPhone}
                    />
                </div>
            </div>
        );
    }
);
DomesticDropdownTemplate.displayName = 'DomesticDropdownTemplate';
